module.exports = __webpack_public_path__ + "static/media/laurenminointeriors - 3.8b34fefd.jpg";